export default __webpack_public_path__ + "static/media/template13.0f137d69.svg";